import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { siteWide } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import srOnly from '@helpers/srOnly';
import { CommonDropdownWrapperStyles, CommonSelectStyles, } from '@stories/Components/Misc/Forms/Inputs/Select/Select.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  &.primary-dark {
    --bgColor: ${brand.primary.purple.dark};
    --fgColor: ${brand.global.white};
  }
`;
const MobileDropdown = styled.div `
  --sitePadding: ${fluid(16, 36)};

  margin-left: calc(var(--sitePadding) * -1);
  padding: var(--sitePadding);
  width: 100vw;
  background-color: var(--bgColor);

  @media ${from(Device.TabletLarge)} {
    display: none;
  }

  label {
    ${srOnly}
  }

  select {
    --borderColour: var(--fgColor) !important;

    ${CommonSelectStyles}
    ${fonts.ubuntu.medium}
    background: var(--bgColor);
    color: var(--fgColor);
    text-align: center;
  }
`;
const SelectWrapper = styled.div `
  ${CommonDropdownWrapperStyles};

  &::after {
    background-color: transparent;
    filter: invert(1);
  }
`;
const Nav = styled.nav `
  display: none;

  @media ${from(Device.TabletLarge)} {
    display: block;
    position: sticky;
    left: 0;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    background-color: var(--bgColor);
  }
`;
const List = styled.ul `
  ${siteWide}
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  gap: 20px;
  padding: 20px;
  min-height: 80px;
`;
const Item = styled.li ``;
const Link = styled.a `
  color: currentColor;
  text-decoration: none;
  ${fonts.ubuntu.medium}

  &:hover,
  &:focus-visible {
    text-decoration: underline;
    text-underline-offset: 2px;
  }
`;
export default {
    Container,
    SelectWrapper,
    MobileDropdown,
    Nav,
    List,
    Item,
    Link,
};
